// DNA2 D615, B493: the catalog's small behaviours. Progressive enhancement only: every link and form here works without it.
//  1. the size-guide link beside the Size label opens the folded "Size chart" row (#ApSizeChart) and scrolls to it;
//  2. the search page's filter form applies at once (a change submits it), and an open filter panel closes when the visitor
//     clicks away or presses Escape; the form's Apply button is inside <noscript>, so it shows only without this script;
//  (the gift finder's script is assets/ap-gift-engine.js since 2026-10-27: it ranks on the page and sends nobody anywhere).
// The favorites heart is NOT here: the one shared favorites script is assets/ap-lab.js (B491).

document.addEventListener('click', event => {
  const link = event.target.closest('[data-ap-size-guide]');
  if (!link) return;
  const row = document.getElementById('ApSizeChart');
  if (!(row instanceof HTMLDetailsElement)) return;
  event.preventDefault();
  row.open = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  row.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
  row.querySelector('summary')?.focus({ preventScroll: true });
});

// the search page's filter form
document.addEventListener('change', event => {
  const form = event.target.closest('[data-apc-filter-form]');
  if (!form) return;
  if (event.target.matches('input[type="number"]')) return; // a price is typed: it applies on Enter or when the field is left
  form.requestSubmit();
});
document.addEventListener(
  'focusout',
  event => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.type === 'number' && input.closest('[data-apc-filter-form]') && input.value !== input.defaultValue) {
      input.closest('form').requestSubmit();
    }
  },
  true
);
const closeFilters = except => {
  document.querySelectorAll('[data-apc-filter][open]').forEach(panel => {
    if (panel !== except) panel.open = false;
  });
};
document.addEventListener('pointerdown', event => closeFilters(event.target.closest('[data-apc-filter]')));
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const open = document.querySelector('[data-apc-filter][open]');
  if (!open) return;
  open.open = false;
  open.querySelector('summary')?.focus();
});
